import { Hero } from "../components/sections/Hero";
import ProblemSolvedByRegTech from "../components/sections/ProblemSolvedByRegTech";
import RegTechFlow from "../components/sections/RegTechFlow";
import KeyFeatures from "../components/sections/KeyFeatures";
import CloudHoisting from "../components/sections/CloudHoisting";
import SecurityPolicy from "../components/sections/SecurityPolicy";
import LatestUpdate from "../components/common/LatestUpdate";

const Dashboard = () => {
  return (
    <div className="flex flex-col gap-8 sm:gap-16 mt-9 lg:mt-[1.6rem]">
      <Hero />
      <ProblemSolvedByRegTech />
      <RegTechFlow />
      <KeyFeatures />
      <CloudHoisting />
      <SecurityPolicy />
      <LatestUpdate />
    </div>
  );
};

export { Dashboard };
